module.exports = __webpack_public_path__ + "img/monique-carstens.52162c38.png";